import * as React from "react";
import { observer } from "mobx-react";
import { createStyles, withStyles} from '@material-ui/core';
import { authStore } from '../auth';
import { history } from "../../history.js";
// E-048 create new Components 
const styles = createStyles({
    root: {
        width: "100%",
        height: "100%",
        margin: "0 auto",
        // padding: "1.5rem",
        display: "flex",
        flexDirection: "column",
    },
});
@observer
class AutoLogOut extends React.Component<any> {
    public componentDidMount = () => {
        authStore.logout(authStore.currentUser.auth_id);
        history.push("/");
    }
    public render() {
        const { classes } = this.props;
        return (
            <>
            </>
        )
    }
}
export default withStyles(styles, { withTheme: true })(
    AutoLogOut
);


// WEBPACK FOOTER //
// ./src/modules/portal/AutoLogout.tsx